import React, {useEffect} from "react";
import DisplayFromCV from "../../../../../patient_data/DisplayFromCV";
import useCvRequest from "./hooks/useCvRequest";
import BridgeStoreV2 from "../../../../../BridgeV2/BridgeStoreV2";
import {toast} from "react-toastify";
import CVStore from "../../../../../CarteVitale/CVStore";
import MesureStore from "../../../MesureStore";
import {isLoading, loading, RequestState} from "../../../../../Shared/StateHelper";
import {observer} from "mobx-react";
import PatientCvDiff from "../../../../../patient_data/PatientCvDiff";

const CarteVitaleButton = observer(({retracted}) => {
    const {sendCVRequest, data, meta} = useCvRequest()

    useEffect(() => {
        const elem = document.getElementById('carte_vitale_modal');
        const modal = M.Modal.init(elem, {onCloseStart: () => null});
        const cvDiffElem = document.getElementById('patient_cv_diff_modal');
        const cvDiffModal = M.Modal.init(cvDiffElem, {onCloseStart: () => null});
        console.log(MesureStore.patient)

        return () => {
            modal.destroy()
            cvDiffModal.destroy()
        }
    }, []);


    const sendRequest = () => {
        if (isLoading(CVStore.cvRequestState)) return
        CVStore.cvRequestState = loading(CVStore.cvRequestState)
        const promise = sendCVRequest(BridgeStoreV2.uid)
        toast.promise(
            promise,
            {
                pending: 'Récupération des données de la carte vitale...',
                success: 'Données de Carte Vitale reçues avec succés !',
                error: 'Impossible de récupérer les données de la carte vitale, Medoc et TemeooDesktop sont-ils bien lancés ?'
            }
        ).then((resp) => {
            CVStore.cvRequestState = RequestState.SUCCESS
            const filterPatient = (data) => {
                const currentPatient = MesureStore.patient
                if (!currentPatient) return data
                const filtered = data.filter((d) => d.sNomUsuelPatient.toLowerCase() === currentPatient.nom.toLowerCase() && d.sPrenomPatient.toLowerCase() === currentPatient.prenom.toLowerCase())
                return filtered.length > 0 ? filtered : data
            }
            const filtered = filterPatient(resp.data)
            // One possible choice : directly select the patient if there is only one
            if (filtered.length === 1) {
                patientSelected(filtered[0], resp.meta)
                return
            }
            M.Modal.getInstance(document.getElementById('carte_vitale_modal')).open()
        }).catch(() => {
            CVStore.cvRequestState = RequestState.ERROR
        })
    }

    const renderButton = () => {
        let color = "blue darken-2"
        if (CVStore.cvRequestState === RequestState.SUCCESS) color = "green darken-2"
        if (CVStore.cvRequestState === RequestState.ERROR) color = "red darken-2"
        if (retracted) return <a className={`btn-small ${color} z-depth-0`} style={{paddingInline: 4}}
                                 onClick={sendRequest}>
            <i className="material-icons">credit_card</i>
        </a>
        return <a className={`btn-small ${color} z-depth-0`} onClick={sendRequest}>
            <i className="material-icons left">credit_card</i>
            Lecture carte vitale
        </a>
    }

    // check
    const checkPatientDiff = (patient, meta) => {
        const fields_to_check = ['firstname', 'lastname', "birthdate"]

        const currentPatient = {
            firstname: MesureStore.patient.prenom,
            lastname: MesureStore.patient.nom,
            birthdate: MesureStore.patient.birthday,
            ssn: MesureStore.patient.num_carte_vitale,
            birth_rank: MesureStore.patient.birth_rank,
            regime_code: MesureStore.patient.regime_code,
            fund_code: MesureStore.patient.fund_code,
            centre_code: MesureStore.patient.centre_code,
        }

        const cvPatient = {
            firstname: patient.sPrenomPatient,
            lastname: patient.sNomUsuelPatient,
            birthdate: patient.dDateDeNaissance,
            ssn: patient.sNumeroSecuriteSociale,
            birth_rank: patient.sRangNaissance,
            regime_code: meta.sCodeRegime,
            fund_code: meta.sCodeCaisse,
            centre_code: meta.sCodeCentre,
        }

        return fields_to_check.reduce((acc, field) => {
            if (currentPatient[field] !== cvPatient[field]) {
                acc.push(field)
            }
            return acc
        }, [])
    }

    const patientSelected = (patient, meta) => {
        M.Modal.getInstance(document.getElementById('carte_vitale_modal')).close()
        const diff = checkPatientDiff(patient, meta)
        if (diff.length > 0) {
            console.log("Patient diff", diff)
            CVStore.diffedPatient = patient
            M.Modal.getInstance(document.getElementById('patient_cv_diff_modal')).open()
            return
        }
        CVStore.updatePatientV2(patient, meta)
    }

    const patientCvDiffModal = () => {
        return <div id="patient_cv_diff_modal" className="modal" style={{width: "90%", borderRadius: "0"}}>
            <div className="modal-content">
                <h1 className="center">Carte vitale</h1>
                <h5 className="center">Des différences entre les données de la carte vitale et celles du patient actuel ont été repérées</h5>
                <PatientCvDiff
                    patient={CVStore.diffedPatient}
                    meta={meta}
                    current_patient={MesureStore.patient}
                    onDone={() => M.Modal.getInstance(document.getElementById('patient_cv_diff_modal')).close()}
                />
            </div>
        </div>
    }

    return <>
        {renderButton()}
        {patientCvDiffModal()}
        <div id="carte_vitale_modal" className="modal" style={{width: "90%", borderRadius: "0"}}>
            <div className="modal-content">
                <h1 className="center">Carte vitale</h1>
                <DisplayFromCV
                    data={data}
                    meta={meta}
                    onClick={(patient) => patientSelected(patient, meta)}/>
            </div>
            <div className="modal-footer">
                <a className="modal-close btn red darken-2 z-depth-0">Annuler</a>
            </div>
        </div>
    </>
})

CarteVitaleButton.defaultProps = {
    retracted: false
};

export default CarteVitaleButton;